import { useNavigate, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { GuardProps } from 'types';

// ==============================|| PROTECTED AUTH GUARD ||============================== //

/**
 * Guard to block direct access to routes
 * Only allows access through redirect/programmatic navigation
 * @param {PropTypes.node} children children element/node
 */

const ProtectedAuthGuard = ({ children }: GuardProps) => {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        // If location.state is null/undefined, user accessed this route directly
        if (!location.state) {
            navigate('/login', { replace: true });
        }
    }, [location.state, navigate]);

    return location.state ? children : null;
};

export default ProtectedAuthGuard;
